import './App.css';
import Main from './componants/Main';
import { CssBaseline } from '@mui/material';


function App() {
  return (
    <div className="App">
      <CssBaseline />
      <Main></Main>
        
    </div>
  );
}

export default App;
